import { Typography } from '@oresundsbron/bridge-ui';

export const VoucherTitle = ({ title }: { title: string }) => (
  <Typography
    as="h3"
    intent="headline"
    color="white"
    className="!mb-0 !text-2xl leading-8 sm:!text-2xl"
    weight="semibold"
  >
    {title}
  </Typography>
);
